export default __webpack_public_path__ + "locales/zh-CN/PDFFormDialog.json?hash=144e6061bd394fc7621d31721bb21614";